import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolsHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "The BIG Tool Shop";
const subtitle = "Dependable tools and accessories, established name brands, and the best value for your money in one convenient place.";

const image = "url('/assets/images/dxp/prebuilt-headers/Tools-Hero.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})